<!-- <p>unlock-chapter-dialog works!</p>
<button mat-dialog-close>BACK</button> -->

<div class="SLV2-unlckchptr-popup-area">

    <button class="SLV2-popup-close-btn">
        <img (click)="checkPreRrequisiteAndNavigate()" src="selflearnv2-ui/assets/img/self-learn-v2/close-black-icon.svg" />
    </button>

    <!-- part 01 open -->
    <ng-container *ngIf="showfreeCount">
    <div class="SLV2-unlckchptr-popup-prt-box">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/explore-avater-01.svg" class="SLV2-unlckchptr-popup-avater" />
        <h5 class="SLV2-unlckchptr-popup-hdng">Yay! This chapter has been unlocked</h5>
        <h6 *ngIf="data?.freeCount-1 > 0" class="SLV2-unlckchptr-popup-subhdng">{{data?.freeCount - 1}} free chapter remaining</h6>
        <button class="SLV2-popup-blue-btn" (click)="navigateToChapterPage()">Explore Chapter</button>
    </div>
    </ng-container>
    <!-- part 01 closed -->


    <!-- part 02 open -->
    <ng-container *ngIf="showSubscription">
    <div class="SLV2-unlckchptr-popup-prt-box">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/explore-avater-02.svg" class="SLV2-unlckchptr-popup-avater avater-02" />
        <h5 class="SLV2-unlckchptr-popup-hdng">Uh-uh! Your trial has expired</h5>
        <h6 class="SLV2-unlckchptr-popup-green-hdng">We've a little something, just for you!</h6>

        <div class="SLV2-coupenboxcont">
            <img src="assets/img/cuponcode-icon.svg" alt="" class="SLV2-gifticonimg" />
            <div class="SLV2-coupen-innertext">Coupon code: INFY10</div>
            <button class="SLV2-copybutton" (click)="copyCoupon('INFY10')"><img src="assets/img/Copy-icon.svg" alt="" class="SLV2-copyicon" />
                    <!--  *ngIf="showCoupon" -->
                <span *ngIf="showCoupon" class="SLV2-tooltip">&#x2713;</span>
            </button>
        </div>

        <button class="SLV2-popup-blue-btn" (click)="navigateToSubscriptions()">Go to Subscriptions</button>
    </div>
    </ng-container>
    <!-- part 02 closed -->


    <!-- part 03 open -->
    <ng-container *ngIf="showCoins">
        <div class="SLV2-unlckchptr-popup-prt-box">
            <div class="SLV2-coin-section">
                <div class="SLV2-coin-box">
                    <img src="selflearnv2-ui/assets/img/Shining-coin1.gif"/><span>{{data?.coins}}</span>
                </div> 
            </div>
            <img src="selflearnv2-ui/assets/img/self-learn-v2/explore-avater-03.svg" class="SLV2-unlckchptr-popup-avater" />
            <h5 class="SLV2-unlckchptr-popup-hdng">Uh-uh! This chapter is locked</h5>
            <h6 class="SLV2-unlckchptr-popup-mdhdng">Unlock this chapter by redeeming {{data?.chapter?.redeemCoinsCount}} coins and continue your journey beyond the trial limit.</h6>
            <button class="SLV2-popup-blue-btn" (click)="navigateToChapterPage()">{{data?.chapter?.redeemCoinsCount}} coins to unlock</button>
        </div>
    </ng-container>
    <!-- part 03 closed -->


    <!-- part 04 open -->
    <ng-container *ngIf="showRedeem">
        <div class="SLV2-unlckchptr-popup-prt-box">
            <div class="SLV2-coin-section">
                <div class="SLV2-coin-box">
                    <img src="selflearnv2-ui/assets/img/Shining-coin1.gif" /><span>{{this.coins}}</span>
                </div>
            </div>
            <img src="selflearnv2-ui/assets/img/self-learn-v2/explore-avater-05.svg" class="SLV2-unlckchptr-popup-avater" />
            <h5 class="SLV2-unlckchptr-popup-hdng">Yay! This chapter has been unlocked</h5>
            <button class="SLV2-popup-blue-btn" (click)="redirectToTopicPage()">Explore Chapter</button>
        </div>
    </ng-container>
    <!-- part 04 closed -->


    <!-- part 05 open -->
    <ng-container *ngIf="false">
        <div class="SLV2-unlckchptr-popup-prt-box">
            <div class="SLV2-coin-section">
                <div class="SLV2-coin-box">
                    <img src="selflearnv2-ui/assets/img/Shining-coin1.gif" /><span>500</span>
                </div>
            </div>
            <img src="selflearnv2-ui/assets/img/self-learn-v2/explore-avater-05.svg" class="SLV2-unlckchptr-popup-avater avater-05" />
            <h5 class="SLV2-unlckchptr-popup-hdng">Yay! This chapter has been unlocked</h5>
            <button class="SLV2-popup-blue-btn">Explore Chapter</button>
        </div>
    </ng-container>
    <!-- part 05 closed -->




</div>
